import axios from 'axios';

import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';
import { SERVER_API_URL } from 'app/config/constants';
import { translate } from 'react-jhipster';

export const ACTION_TYPES = {
  ONLINE_ENQUIRY: 'static/ONLINE_ENQUIRY',
  RESET: 'static/RESET'
};

const initialState = {
  enquirySuccess: false,
  enquiryFailure: false
};

export type StaticPageState = Readonly<typeof initialState>;

// Reducer
export default (state: StaticPageState = initialState, action): StaticPageState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.ONLINE_ENQUIRY):
      return {
        ...state
      };
    case FAILURE(ACTION_TYPES.ONLINE_ENQUIRY):
      return {
        ...state,
        enquiryFailure: true
      };
    case SUCCESS(ACTION_TYPES.ONLINE_ENQUIRY):
      return {
        ...state,
        enquirySuccess: true
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

// Actions
export const onlineEnquiry = enquiry => ({
  type: ACTION_TYPES.ONLINE_ENQUIRY,
  payload: axios.post(SERVER_API_URL + '/api/onlineEnquiry', enquiry),
  meta: {
    successMessage: translate('global.form.success')
  }
});

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
